import { EndpointResource } from "../core/conf/endpoint_conf";

export enum ErrorType {
    TIMEOUT = 'timeout',
    SESSION_POST = 'session_post',
    PRE_AUTH = 'pre_auth',
    AUTH = 'auth',
    POST_AUTH = 'post_auth',
    ENROLL = 'enroll',
    UNKNOWN = 'unknown',
    DATA_CONVERT = 'data_convert',
    STATUS_0 = 'status_0',
    DATA_COLLECTION_TIMEOUT = 'data_collection_timeout',
    UNEXPECTED_DATA_COLLECTION_RESPONSE = 'unexpected_data_collection_response',
    CSP_VIOLATION = 'csp_violation'
}

export namespace ErrorType {
    const endpointMap: Partial<Record<ErrorType, string>> = {
        [ErrorType.PRE_AUTH]: EndpointResource.preAuthEndpoint,
        [ErrorType.AUTH]: EndpointResource.authEndpoint,
        [ErrorType.POST_AUTH]: EndpointResource.postAuthEndpoint,
        [ErrorType.ENROLL]: EndpointResource.enrollEndpoint,
    };

    export function toEndpoint(type: ErrorType): string {
        return endpointMap[type] ?? "";
    }
}

export enum AuthResponseStatus {
    AUTENTICADA = 'AUTENTICADA',
    PENDIENTE_AUTENTICAR = 'PENDIENTE_AUTENTICAR',
    FALLIDA = 'FALLIDA'
}

export enum TokenizationFlowStep {
    IDLE,
    AUTHENTICATING,
    ENROLLING,
    SUCCESS,
} 
